import { StyleFunctionProps, extendTheme } from '@chakra-ui/react'

const textBold = 600
const textLight = 400
const noSelectStyle = {
  userSelect: 'none',
};

const theme = extendTheme({
  textStyles: {
    heading: {
      100: {
        fontSize: '40px',
        fontWeight: '500',
        lineHeight: '58px',
        letterSpacing: '0',
      },
      200: {
        fontSize: '32px',
        fontWeight: '500',
        lineHeight: '38px',
        letterSpacing: '0',
      },
      300: {
        fontSize: '24px',
        fontWeight: '500',
        lineHeight: '30px',
        letterSpacing: '0',
      },
      400: {
        fontSize: '22px',
        fontWeight: '500',
        lineHeight: '28px',
        letterSpacing: '0',
      },
      500: {
        fontSize: '20px',
        fontWeight: '500',
        lineHeight: '26px',
        letterSpacing: '0',
      },
      600: {
        fontSize: '18px',
        fontWeight: '500',
        lineHeight: '20px',
        letterSpacing: '0',
      },
      700: {
        fontSize: '22px',
        fontWeight: '500',
        lineHeight: '16px',
        letterSpacing: '0',
      },
      800: {
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '20px',
        letterSpacing: '0',
      },
    },
    subheading: {
      100: {
        fontSize: '32px',
        fontWeight: '500',
        lineHeight: '36px',
        letterSpacing: '1',
      },
      200: {
        fontSize: '18px',
        fontWeight: '500',
        lineHeight: '22px',
        letterSpacing: '0.5',
      },
      300: {
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: '20px',
        letterSpacing: '0.5',
      },
      400: {
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '18px',
        letterSpacing: '0.5',
      },
      500: {
        fontSize: '12px',
        fontWeight: '500',
        lineHeight: '16px',
        letterSpacing: '0.5',
      },
    },
    heavy: {
      100: {
        fontSize: '18px',
        fontWeight: textBold,
        lineHeight: '24px',
        letterSpacing: '0',
      },
      200: {
        fontSize: '16px',
        fontWeight: textBold,
        lineHeight: '22px',
        letterSpacing: '0',
      },
      300: {
        fontSize: '14px',
        fontWeight: textBold,
        lineHeight: '20px',
        letterSpacing: '0',
      },
      400: {
        fontSize: '12px',
        fontWeight: textBold,
        lineHeight: '18px',
        letterSpacing: '0',
      },
      500: {
        fontSize: '10px',
        fontWeight: textBold,
        lineHeight: '16px',
        letterSpacing: '0',
      },
      0: {
        fontSize: '24px',
        fontWeight: textBold,
        lineHeight: '32px',
        letterSpacing: '0',
      },
    },
    medium: {
      100: {
        fontSize: '18px',
        fontWeight: '500',
        lineHeight: '24px',
        letterSpacing: '0',
      },
      200: {
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: '22px',
        letterSpacing: '0',
      },
      300: {
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '20px',
        letterSpacing: '0',
      },
      400: {
        fontSize: '12px',
        fontWeight: '500',
        lineHeight: '18px',
        letterSpacing: '0',
      },
      500: {
        fontSize: '10px',
        fontWeight: '500',
        lineHeight: '16px',
        letterSpacing: '0',
      },
      0: {
        fontSize: '24px',
        fontWeight: '500',
        lineHeight: '32px',
        letterSpacing: '0',
      },
    },
    light: {
      100: {
        fontSize: '18px',
        fontWeight: textLight,
        lineHeight: '24px',
        letterSpacing: '0',
      },
      200: {
        fontSize: '16px',
        fontWeight: textLight,
        lineHeight: '22px',
        letterSpacing: '0',
      },
      300: {
        fontSize: '14px',
        fontWeight: textLight,
        lineHeight: '20px',
        letterSpacing: '0',
      },
      400: {
        fontSize: '12px',
        fontWeight: textLight,
        lineHeight: '18px',
        letterSpacing: '0',
      },
      500: {
        fontSize: '10px',
        fontWeight: textLight,
        lineHeight: '16px',
        letterSpacing: '0',
      },
      0: {
        fontSize: '24px',
        fontWeight: textLight,
        lineHeight: '32px',
        letterSpacing: '0',
      },
    },
    buttons: {
      100: {
        fontSize: '18px',
        fontWeight: '500',
        lineHeight: '22px',
        letterSpacing: '0.5',
      },
      200: {
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: '20px',
        letterSpacing: '0.5',
      },
      300: {
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '18px',
        letterSpacing: '0.5',
      },
      400: {
        fontSize: '12px',
        fontWeight: '500',
        lineHeight: '16px',
        letterSpacing: '0.5',
      },
      500: {
        fontSize: '10px',
        fontWeight: '500',
        lineHeight: '14px',
        letterSpacing: '0.5',
      },
    },
  },

  fontSizes: {
    xs: '12px',
    sm: '13px',
    md: '15px',
    lg: '17px',
    xl: '19px',
    '2xl': '22px',
    '3xl': '22px',
    '4xl': '28px',
    '5xl': '34px',
  },
  fonts: {
    body: 'SFProText-Regular, sans-serif',
    heading: 'SFProText-Bold, sans-serif',
  },
  styles: {
    global: {
      body: {
        bg: '#ffffff',
      },
    },
  },
  components: {
    Divider: {
      baseStyle: {
        borderColor: '#DCE2EA',
        ...noSelectStyle,
      },
    },
    Button: {
      baseStyle: {
        borderRadius: '4px',
        fontWeight: '500',
        fontSize: '17px',
        lineHeight: '22px',
      },
      variants: {
        outline: {
          bg: 'transparent',
          color: '#3B4654',
          borderRadius: '6px',
          border: '1px solid #DCE2EA',
          _hover: { bg: '#DCE2EA' },
          _active: { bg: '#d3d4d7' },
        },
        heavy: {
          bg: '#171C22',
          color: '#fff',
          borderRadius: '128px',
          _hover: {
            bg: '#0c0e11',
            _disabled: {
              bg: '#F5F7F9',
              color: '#7E8B9A',
              opacity: '1',
            },
          },
          _active: { bg: '#000' },
          _disabled: {
            bg: '#F5F7F9',
            color: '#7E8B9A',
            opacity: '1',
          },
        },
        light: {
          bg: '#F5F7F9',
          color: '#171C22',
          borderRadius: '128px',
          _hover: {
            bg: '#c4c4c4',
            _disabled: {
              opacity: '0.7',
              bg: '#F5F7F9',
              color: '#7E8B9A',
            },
          },
          _active: { bg: '#d8d9dd' },
          _disabled: {
            opacity: '0.7',
            bg: '#F5F7F9',
            color: '#7E8B9A',
          },
        },
        link: {
          color: '#000',
          _hover: { textDecoration: 'underline' },
        },
        subtleLink: {
          padding: '0px',
          color: '#7E8B9A',
          fontWeight: '400',
          _hover: { textDecoration: 'underline' },
        },
      },
    },
    Checkbox: {
      variants: {
        light: {
          control: {
            bg: 'darkBlue.400',
            color: 'gray.50',
            borderColor: 'dark.50',
            borderRadius: '3px',
            border: '1px solid #7E8B9A',
            transition: '0.2s',
            width: '18px',
            height: '18px',

            _hover: {
              bg: '#E7EAF4',
              color: 'white',
              border: '1px solid #7E8B9A',
              _checked: {
                bg: 'black',
                border: '1px solid black',
              },
            },
            _checked: {
              bg: 'black',
              color: 'white',
              borderColor: 'black',
            },
          },
          label: {
            fontWeight: '500',
            color: '#3B4654',
          },
        },
        heavy: {
          control: {
            bg: 'darkBlue.400',
            color: 'gray.50',
            borderColor: 'dark.50',
            borderRadius: '3px',
            border: '1px solid #7E8B9A',
            transition: '0.2s',
            width: '18px',
            height: '18px',

            _hover: {
              bg: '#E7EAF4',
              color: 'white',
              border: '1px solid #7E8B9A',
              _checked: {
                bg: 'black',
                border: '1px solid black',
              },
            },
            _checked: {
              bg: 'black',
              color: 'white',
              borderColor: 'black',
            },
          },
          label: {
            fontWeight: '500',
            color: '#171C22',
          },
        },
        // Attendee check-in control: a circular checkbox that reads as an empty
        // ring when unchecked and fills solid green (with a white check) when
        // checked — used in the event attendee list (UserSelectModal).
        checkin: {
          control: {
            width: '24px',
            height: '24px',
            borderRadius: '9999px',
            bg: 'white',
            color: 'white',
            border: '2px solid #C6CED8',
            transition: 'background 0.15s ease, border-color 0.15s ease',
            _hover: {
              borderColor: '#22C55E',
            },
            _checked: {
              bg: '#22C55E',
              color: 'white',
              borderColor: '#22C55E',
              _hover: {
                bg: '#16A34A',
                borderColor: '#16A34A',
              },
            },
            _focusVisible: {
              boxShadow: '0 0 0 3px rgba(34, 197, 94, 0.35)',
            },
          },
        },
      },
      defaultProps: {
        variant: 'heavy',
      },
    },
    FormLabel: {
      baseStyle: {
        color: '#3B4654',
        fontWeight: '500',
        fontSize: '17px',
        lineHeight: '22px',
      },
    },
    FormErrorMessage: {
      fontWeight: '500',
      fontSize: '15px',
      lineHeight: '20px',
      color: '#FF3B30',
    },
    Input: {
      variants: {
        default: (props: StyleFunctionProps) => ({
          field: {
            fontSize: '16',
            fontWeight: '400',
            lineHeight: '21px',
            borderRadius: '4px',
            bg: 'transparent',
            borderColor: props.isInvalid ? '#FF3B30' : '#DCE2EA',
            borderWidth: '1.5px',
            _placeholder: { color: '#171C22', opacity: '40%' },
          },
        }),
        filled: (props: StyleFunctionProps) => ({
          field: {
            fontSize: '16',
            fontWeight: '400',
            lineHeight: '21px',
            borderRadius: '10px',
            bg: '#F5F7F9',
            borderColor: props.isInvalid ? '#FF3B30' : '#F5F7F9',
            borderWidth: '1.5px',
            _placeholder: { color: '#171C22', opacity: '40%' },
            _hover: {
              borderColor: props.isInvalid ? '#FF3B30' : '#eceef2',
              bg: '#eceef2',
            },
            _focus: {
              borderColor: props.isInvalid ? '#FF3B30' : '#eceef2',
              bg: '#eceef2',
            },
          },
        }),
      },
      defaultProps: {
        variant: 'default',
      },
    },
    Textarea: {
      variants: {
        default: (props: StyleFunctionProps) => ({
          field: {
            fontSize: '16',
            fontWeight: '400',
            lineHeight: '21px',
            borderRadius: '4px',
            bg: 'transparent',
            borderColor: props.isInvalid ? '#FF3B30' : '#DCE2EA',
            borderWidth: '2px',
            _placeholder: { color: '#171C22', opacity: '40%' },
          },
        }),
      },
      defaultProps: {
        variant: 'default',
      },
    },
    Select: {
      variants: {
        default: {
          field: {
            borderRadius: '128px',
            transition: '0.2s ease-out',

            bg: 'transparent',
            color: '#171C22',
            border: '1px solid #DCE2EA',
            _hover: { bg: '#DCE2EA' },
            _active: { bg: '#d3d4d7' },
          },
        },
        input: (props: StyleFunctionProps) => ({
          field: {
            fontSize: '16',
            fontWeight: '400',
            lineHeight: '21px',
            borderRadius: '4px',
            bg: 'transparent',
            borderColor: props.isInvalid ? '#FF3B30' : '#DCE2EA',
            borderWidth: '1.5px',
            _placeholder: { color: '#171C22', opacity: '40%' },
          },
        }),
        filled: (props: StyleFunctionProps) => ({
          field: {
            fontSize: '16',
            fontWeight: '400',
            lineHeight: '21px',
            borderRadius: '10px',
            bg: '#F5F7F9',
            borderColor: props.isInvalid ? '#FF3B30' : '#F5F7F9',
            borderWidth: '1.5px',
            _placeholder: { color: '#171C22', opacity: '40%' },
            _hover: {
              borderColor: props.isInvalid ? '#FF3B30' : '#eceef2',
              bg: '#eceef2',
            },
            _focus: {
              borderColor: props.isInvalid ? '#FF3B30' : '#eceef2',
              bg: '#eceef2',
            },
          },
        }),
      },
      defaultProps: {
        variant: 'default',
      },
    },
    Switch: {
      variants: {
        default: {
          track: {
            bg: '#DCE2EA',
            _checked: {
              bg: '#06C270',
              _focus: {
                boxShadow: 'none',
              },
            },
          },
          thumb: {
            bg: 'white',
          },
        },
      },
      defaultProps: {
        variant: 'default',
        focusBorderColor: 'none',
      },
    },
    Text: {
      variants: {
        title: {
          color: '#171C22',
          fontWeight: '500',
          fontSize: '22px',
          lineHeight: '28px',
        },
        subtle: {
          color: '#7E8B9A',
          fontWeight: '400',
        },
        detail: {
          color: '#3B4654',
          fontWeight: '400',
        },
        card: {
          userSelect: 'none',
          color: 'white',
          fontWeight: '600',
          fontSize: '22px',
          lineHeight: '22px',
        },
        cardTitle: {
          userSelect: 'none',
          color: 'white',
          fontWeight: '700',
          fontSize: '36px',
          lineHeight: '36px',
        },
      },
    },
    Modal: {
      baseStyle: {
        dialog: {
          bg: 'white',
          borderRadius: '10px',
          padding: '20px 20px 0px 20px',
        },
        header: {
          bg: 'white',
          borderRadius: '10px',
          color: '#171C22',
          fontSize: '34px',
          lineHeight: '41px',
          fontWeight: '500',
          padding: '20px 20px 5px 20px',
        },
        footer: {
          padding: '20px',
        },
      },
      defaultProps: {
        isCentered: true,
      },
    },
    Tag: {
      variants: {
        shadow: {
          container: {
            borderRadius: '128px',
            background: '#171C2280',
            color: '#F5F7F9',
            fontWeight: '500',
            fontSize: '12px',
          },
        },
        outlined: {
          container: {
            borderRadius: '128px',
            border: '0.5px solid #DCE2EA',
            fontWeight: '500',
            color: '#000',
            height: '32px',
            padding: '0px 20px',
            transition: '0.2s',
          },
        },
        light: {
          container: {
            borderRadius: '128px',
            fontWeight: '500',
            color: '#171C22',
            bg: '#F5F7F9',
            height: '32px',
            padding: '0px 20px',
          },
        },
        heavy: {
          container: {
            borderRadius: '128px',
            fontWeight: '500',
            color: 'white',
            bg: '#171C22',
            height: '32px',
            padding: '0px 20px',
          },
        },
        outline_interactive: {
          container: {
            borderRadius: '128px',
            border: '0.5px solid #DCE2EA',
            fontWeight: '500',
            color: '#000',
            height: '32px',
            _hover: { bg: '#e9f0f8' },
            _active: { bg: '#DCE2EA' },
            transition: '0.2s',
            cursor: 'pointer',
          },
        },
      },
    },
    Radio: {
      baseStyle: {
        control: {
          borderRadius: '50%',
          border: '2px solid',
          borderColor: '#DCE2EA',
          transition: '0.2s ease-out',
          _hover: {
            bg: '#DCE2EA',
          },
          _checked: {
            bg: '#171C22',
            borderColor: '#171C22',
            _hover: {
              bg: '#171C22',
              borderColor: '#171C22',
            },
          },
        },
        label: {
          color: '#171C22',
          fontWeight: '400',
        },
      },
    },
    Slider: {
      baseStyle: {
        thumb: {
          width: '20px',
          height: '20px',
          bg: '#171C22',
          borderRadius: '50%',
        },
        filledTrack: {
          bg: '#171C22',
        },
        track: {
          bg: '#F5F7F9',
        },
      },
    },
    MenuList: {
      default: {},
      defaultProps: {
        variant: 'default',
      },
    },
  },
})

export default theme
